import alert_mixin from '@/utils/mixins/alert_mixin';
import { computed, watch } from './service_layer_agreement.computed';
import {
  DEFAULT_CREATE_FORM,
  createDefaultWorkflowForm,
} from './service_layer_agreement.helpers';
import list_methods from './service_layer_agreement.list_methods';
import modal_methods from './service_layer_agreement.modal_methods';

export default {
  name: 'ServiceLayerAgreement',
  mixins: [alert_mixin],
  data: () => ({
    loading: false,
    saving: false,
    search_query: '',
    filter_mode: 'all',
    sort_mode: 'updated_desc',
    current_page: 1,
      page_size: 10,
      sla_configs: [],
      workflow_options: [],
      create_form: DEFAULT_CREATE_FORM(),
      workflow_form: createDefaultWorkflowForm(),
      workflow_saving: false,
    }),
  computed,
  watch,
  mounted() {
    this.fetch_sla_configs();
    this.fetch_workflow_options();
  },
  methods: {
    ...list_methods,
    ...modal_methods,
  },
};
